import { t } from "i18next";
import { Fragment, useState } from "react";

import ArrowUpRight from "@/assets/icons/arrow-up-right.svg?react";

import { MinterScore } from "./components/MinterScore";
import styles from "./styles";
import { SheetModal } from "../index";
import { SheetTitle } from "../styles";

export const useFAQModal = () => {
  const [isOpen, setOpen] = useState<boolean>(false);
  const [type, setType] = useState<null | "mintedScore" | "mintedEVMScore">(null);

  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setType(null);
    setOpen(false);
  };

  const faq = [
    {
      title: t("Modals.FAQ.MintedScore"),
      handler: () => setType("mintedScore"),
    },
  ];

  const renderContent = () => {
    switch (type) {
      case "mintedScore": {
        return (
          <styles.Container>
            <styles.Back>
              <ArrowUpRight onClick={() => setType(null)} />
            </styles.Back>
            <MinterScore closeModal={closeModal} />
          </styles.Container>
        );
      }

      default:
        return (
          <styles.Container>
            <SheetTitle>{t("Modals.FAQ.Title")}</SheetTitle>
            <styles.List>
              {faq.map(({ title, handler }, index, arr) => (
                <Fragment key={title}>
                  <styles.Faq onClick={handler}>
                    <span>{title}</span>
                    <ArrowUpRight />
                  </styles.Faq>
                  {arr.length !== index + 1 && <hr />}
                </Fragment>
              ))}
            </styles.List>
          </styles.Container>
        );
    }
  };

  const modal = (
    <SheetModal isOpen={isOpen} closeModal={closeModal} detent="content-height">
      {renderContent()}
    </SheetModal>
  );

  return { isOpen, openModal, closeModal, modal };
};
